import axios from 'axios';

import { getDecoded, getVoiceToken } from '../../utils/voiceToken/voiceToken';
import { getServiceURI } from '../../globals/serviceURI/serviceURI';
import { LANGUAGES_PATH } from '../../constants';

/**
 * @param languages
 * @returns {Promise<Array>}
 */
export default async (languages = 'en-US') => {
  const token = getDecoded();

  if (!token) {
    throw Error('Must call authenticate first to get voice token');
  }

  if (Math.floor(Date.now() / 1000) >= token.exp) {
    throw Error('Voice token expired');
  }

  const { data } = await axios.request({
    method: 'get',
    url: `${getServiceURI()}${LANGUAGES_PATH}`,
    headers: {
      Authorization: `Bearer ${getVoiceToken()}`,
    },
    params: {
      languages,
    },
  });

  return data.languages;
};
